module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-green-c1186b5d88b5b57e2e894b8798343fe7.svg";